export default __webpack_public_path__ + "static/media/GCR Aviation.31d6cfe0.title";